<template>
  <shared-step-editor-form-field
    :error="error"
    :error-position="errorPosition"
    :height="height"
    :hint="hint"
    :field-id="inputId"
    :label="inputValue ? label : ''"
    class="shared-step-editor-input-field"
    @click="setFocus"
  >
    <span class="shared-step-editor-input-field__prefix">
      <slot name="prefix" />
    </span>
    <input
      :value="inputValue"
      :id="inputId"
      ref="input"
      :autocomplete="autocomplete"
      :placeholder="placeholder || label"
      :maxlength="maxlength"
      class="shared-step-editor-input-field__input"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      @input="onInput"
    />
  </shared-step-editor-form-field>
</template>

<script setup>
import SharedStepEditorFormField from './SharedStepEditorFormField';
import {generateUuid} from '../../../../../utility/generateUuid';

export default {
  components: {
    SharedStepEditorFormField,
  },
  props: {
    inputValue: String,
    autofocus: Boolean,
    autocomplete: String,
    error: String,
    errorPosition: {
      type: String,
      default: 'absolute',
    },
    fieldId: String,
    height: {
      type: Number,
      default: 52,
    },
    label: String,
    hint: String,
    id: String,
    maxlength: Number,
    placeholder: String,
  },
  data: () => ({
    inputId: null,
  }),
  methods: {
    onInput(e) {
      this.$emit('input', e.target.value);
    },
    setFocus() {
      if (this.autofocus) {
        setTimeout(() => this.$refs.input.focus(), 100);
      }
    },
  },
  mounted() {
    this.setFocus();
  },
  created() {
    this.inputId = this.fieldId || `input-${generateUuid()}`;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/web/_variables.scss';

.shared-step-editor-input-field {
  cursor: text;
  &__grow {
    display: grid;
    width: 100%;
    line-height: 20px;
    &::after {
      content: attr(data-replicated-value) ' ';
      white-space: pre-wrap;
      visibility: hidden;
      padding: 10px 16px;
      grid-area: 1 / 1 / 2 / 2;
    }
  }

  &__input {
    background: transparent;
    caret-color: inherit;
    color: inherit;
    flex-grow: 1;
    font-size: 14px;
    height: 100%;
    outline: none;
    padding: 0 10px;
    width: 100%;
    grid-area: 1 / 1 / 2 / 2;
    height: 44px;
    border: none;
    outline: none;

    &::placeholder {
      color: $color-gunsmoke;
    }
  }
  &__prefix {
    color: $color-gunsmoke;
    display: flex;
  }
}
</style>
